var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('ButtonModuleUiPresentation',_vm._b({attrs:{"alignment":_vm.data.alignment}},'ButtonModuleUiPresentation',_vm.resolvedData,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }